import { render, staticRenderFns } from "./NbCardItemsManyAttributes.vue?vue&type=template&id=74f68f80&scoped=true&"
import script from "./NbCardItemsManyAttributes.vue?vue&type=script&lang=js&"
export * from "./NbCardItemsManyAttributes.vue?vue&type=script&lang=js&"
import style0 from "./NbCardItemsManyAttributes.vue?vue&type=style&index=0&id=74f68f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f68f80",
  null
  
)

export default component.exports